import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginUser: null,
  },

  mutations: {
    login(state, loginUser) {
      state.loginUser = loginUser;
    },

    logout(state) {
      state.loginUser = null;
    },
  },

  actions: {
    login(context, payload) {
      context.commit("login", payload);
    },

    logout(context) {
      context.commit("logout");
    },
  },

  getters: {
    getAuthToken(state) {
      if (state.loginUser) {
        return state.loginUser.attributes.auth_token;
      } else {
        return state.loginUser;
      }
    },
  },

  plugins: [createPersistedState()],

  modules: {},
});
